import styles from './UserEmailNotifications.module.scss';
import Switch from '../../common/Switch';
import Select from '../../common/Select';
import React, { useCallback, useMemo } from 'react';
import { NOTIFICATION_IMMEDIATE, NOTIFICATION_SUMMARY } from '../../../constants/emailNotifications';
import { useDispatch, useSelector } from 'react-redux';
import { updateCurrentUser, updateLoadingNotifications } from '../../../store/actions/users';

const defaultNotificationOptions = [
  { value: NOTIFICATION_SUMMARY, label: 'Daily' },
  { value: NOTIFICATION_IMMEDIATE, label: 'Immediate' },
];

export default function NotificationTableRow({ defaultNotification, name, userNotification, notificationOptions }) {
  const dispatch = useDispatch();
  const { notifications: userNotifications } = useSelector((state) => state.role.user.preferences);
  const isEnabled = useMemo(() => {
    const isUserNotificationDisabled = userNotification?.hasOwnProperty('enabled') ? userNotification.enabled : false;
    return defaultNotification.disabled ? true : isUserNotificationDisabled;
  }, [defaultNotification, userNotification]);

  const frequency = useMemo(
    () => userNotification?.frequency || defaultNotification.value,
    [userNotification, defaultNotification],
  );

  const updateNotification = useCallback(
    (name, frequency, enabled = true) => {
      try {
        dispatch(updateLoadingNotifications(true));

        const newNotifications = {
          ...userNotifications,
          [name]: { frequency, enabled },
        };

        dispatch(
          updateCurrentUser({
            preferences: {
              notifications: newNotifications,
            },
          }),
        );
      } finally {
        setTimeout(() => dispatch(updateLoadingNotifications()), 1000);
      }
    },
    [userNotifications, dispatch],
  );

  return (
    <tr>
      <td className={defaultNotification.description ? styles.withDescription : ''}>
        {defaultNotification.label}
        {defaultNotification.description && <div className={styles.description}>{defaultNotification.description}</div>}
      </td>
      <td>
        <Switch
          checked={isEnabled}
          onSwitch={(isEnabled) => updateNotification(name, frequency, isEnabled)}
          disabled={defaultNotification.disabled}
        />
      </td>
      <td>
        <Select
          options={notificationOptions ?? defaultNotificationOptions}
          onChange={(frequency) => updateNotification(name, frequency)}
          value={frequency}
          name={name}
          inline
          disabled={defaultNotification.disabled || !isEnabled}
        />
      </td>
    </tr>
  );
}
